
import { computed } from "vue";
import { Options } from "vue-class-component";
import BaseTag from "../BaseTag.vue";

@Options({})
export default class IziCol extends BaseTag {
  public bindingClass = computed(() => this.mergeClass());
  mergeClass() {
    const col = this.col ? `p-col-${this.col}` : "p-col-12";
    const sm = this.sm ? `p-sm-${this.sm}` : "";
    const md = this.md ? `p-md-${this.md}` : "";
    const lg = this.lg ? `p-lg-${this.lg}` : "";
    const xl = this.xl ? `p-xl-${this.xl}` : "";
    const cl = this.class ? `${this.class}` : "";
    return `${cl} ${col} ${sm} ${md} ${lg} ${xl}`;
  }
}
